import { ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { TabContentComponent } from '../tab-content/tab-content.component';

@Component({
    selector: 'il-tabs-group',
    templateUrl: './tabs-group.component.html',
    styleUrls: ['./tabs-group.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabsGroupComponent {
    @Input() disableRipple = true;
    @Input() animationDuration = '0ms';
    @ContentChildren(TabContentComponent, {
        descendants: true,
    }) tabsContentList!: QueryList<TabContentComponent>;
}